import { defineMessages } from 'react-intl';

export const i18n: {
	manifestDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manifestTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referenceDatabaseTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referenceDatabaseDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referenceDatabaseModalLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createDatabaseIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referenceDatabaseIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentPageMovedErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	parentPageMovedErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permissionRemovedErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permissionRemovedErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidParentErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidParentErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseDefaultTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseDefaultDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseDefaultIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	manifestDescription: {
		id: 'confluence-databases-extension.description',
		defaultMessage: 'Create an empty database table',
		description: 'Description for database editor extension.',
	},
	manifestTitle: {
		id: 'confluence-databases-extension.title',
		defaultMessage: 'Database extension',
		description:
			'The text is shown as the title label for the Confluence database editor extension, which appears in the editor extension manifest or extension panel when the database editor feature is available.',
	},
	referenceDatabaseTitle: {
		id: 'confluence-databases-extension.reference-database.title',
		defaultMessage: 'Embed database',
		description: 'Title for reference database quick insert action.',
	},
	referenceDatabaseDescription: {
		id: 'confluence-databases-extension.reference-database.description',
		defaultMessage: 'Display an existing database, entry, or value',
		description: 'Description for reference database quick insert action.',
	},
	referenceDatabaseModalLabel: {
		id: 'confluence-databases-extension.reference-database.modal-label',
		defaultMessage: 'Reference database modal',
		description:
			'The text is used as the accessible label for the reference database modal dialog, which appears when a user links or references an existing database from within a Confluence page or database.',
	},
	createDatabaseIconAltText: {
		id: 'confluence-databases-extension.create-database.icon-alt-text',
		defaultMessage: 'Create database icon',
		description: 'Alt text for create database quick insert action icon.',
	},
	referenceDatabaseIconAltText: {
		id: 'confluence-databases-extension.reference-database.icon-alt-text',
		defaultMessage: 'Reference database icon',
		description: 'Alt text for reference database quick insert action icon.',
	},
	successFlagTitle: {
		id: 'confluence-databases-extension.success-flag.title',
		defaultMessage: 'Database added under this content ',
		description: 'Title for success flag when database is created inline.',
	},
	successFlagAction: {
		id: 'confluence-databases-extension.success-flag.action',
		defaultMessage: 'Open database in new tab',
		description: 'Action for success flag when database is created inline.',
	},
	successFlagDescription: {
		id: 'confluence-databases-extension.success-flag.description',
		defaultMessage: 'To view this database in full and edit it with ease, open it in a new tab.',
		description: 'Description for success flag when database is created inline.',
	},
	defaultErrorFlagTitle: {
		id: 'confluence-databases-extension.error-flag.title',
		defaultMessage: 'We’re unable to create right now',
		description: 'Title for default flag when database is created inline.',
	},
	defaultErrorFlagDescription: {
		id: 'confluence-databases-extension.error-flag.description',
		defaultMessage:
			'Refresh or wait a few minutes and try again. If this keeps happening, contact support.',
		description: 'Description for success flag when database is created inline.',
	},
	parentPageMovedErrorTitle: {
		id: 'confluence-databases-extension.error.parent-page-moved-error-title',
		defaultMessage: 'The parent has moved',
		description:
			'Title for error flag when the page is moved when trying to create a database inline.',
	},
	parentPageMovedErrorDescription: {
		id: 'confluence-databases-extension.error.parent-page-moved-error-description',
		defaultMessage: 'Refresh to create in the new location.',
		description:
			'Description for error flag when the page is moved when trying to create a database inline.',
	},
	permissionRemovedErrorTitle: {
		id: 'confluence-databases-extension.error.permission-removed-error-title',
		defaultMessage: 'We’re unable to create this content',
		description:
			'Title for error flag when the user encounters a permissions issue while creating content or tries to create content in a nonexistent space',
	},
	permissionRemovedErrorDescription: {
		id: 'confluence-databases-extension.error.permission-removed-error-description',
		defaultMessage:
			'You don’t have permission to create here or the space has been recently deleted.',
		description:
			'Description for error flag when the user encounters a permissions issue while creating content or tries to create content in a nonexistent space.',
	},
	invalidParentErrorTitle: {
		id: 'confluence-databases-extension.error.invalid-parent-error-title',
		defaultMessage: 'We can’t create a database',
		description:
			'Title for error flag when the page is deleted or archived when trying to create a database inline.',
	},
	invalidParentErrorDescription: {
		id: 'confluence-databases-extension.error.invalid-parent-error-description.livedocs',
		defaultMessage:
			'This item was deleted or archived. You can create a database on a different page or live doc.',
		description:
			'Updated version of confluence-databases-extension.error.invalid-parent-error-description',
	},
	databaseDefaultTitle: {
		id: 'confluence-databases-extension.database-default.title',
		defaultMessage: 'Database',
		description: 'Title for default create database quick insert action.',
	},
	databaseDefaultDescription: {
		id: 'confluence-databases-extension.database-default.description',
		defaultMessage: 'Organize and sync information in a database',
		description: 'Description for default create database quick insert action.',
	},
	databaseDefaultIconAltText: {
		id: 'confluence-databases-extension.database-default.icon-alt-text',
		defaultMessage: 'Database icon',
		description: 'Alt text for default create database action icon.',
	},
});
